import React, { useState } from 'react';
import { TelegramCircleIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { blokTestConst } from 'modules/blok-test';
import { IMyResult } from 'modules/mavzuli-test';
import { useTestResults } from 'modules/results';

import { Visible } from 'components';

import XpModal from '../xp-modal';

import ActionSection from './action-section';
import PassingScoreSection from './passing-score-section';
import ResultImage from './result-image';
import ResultStatistics from './result-statistics';
import TestsBlock from './tests-block';

interface IProps {
  ticketId?: string;
  myResults?: IMyResult;
}

const Result: React.FC<IProps> = ({ myResults, ticketId }) => {
  const t = useTranslations();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const currentTest = myResults?.result?.[selectedIndex];
  const { correctAnswersCount, totalQuestions, incorrectAnswers } = useTestResults(myResults);

  return (
    <div className="rounded-xl bg-white p-4">
      <Visible
        if={myResults?.type === blokTestConst.testTypes.TOPIC_TEST}
        else={
          <>
            <ResultImage myResults={myResults} />
            <p className="my-4 text-center text-lg font-medium">{myResults?.user}</p>
          </>
        }
      >
        <div className="relative mb-5 mt-60 flex flex-col items-center justify-center">
          <Image src="/images/xp-image.png" width={300} height={300} alt="xp-images" className="-top-66 absolute" />
          <h1 className="flex items-end gap-2 text-4xl font-bold">
            <span>+{Number.isInteger(myResults?.ball) ? myResults?.ball : 5}</span>
            <span className="text-2xl font-medium text-gray-400">XP</span>
          </h1>
        </div>
        <XpModal totalXp={Number.isInteger(myResults?.ball) ? myResults?.ball : 5} />
      </Visible>

      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        <ResultStatistics
          totalQuestions={totalQuestions}
          incorrectAnswers={incorrectAnswers}
          correctAnswersCount={correctAnswersCount}
        />
        <PassingScoreSection myResults={myResults} lessonName={currentTest?.lesson_name} />
      </div>

      <TestsBlock currentTest={currentTest} myResults={myResults} setSelectedIndex={setSelectedIndex} />
      <Link
        target="_blank"
        href={`${process.env.NEXT_PUBLIC_TELEGRAM}`}
        className="relative mt-4 block rounded-xl !bg-green-100 p-3 text-center text-xs font-medium !text-gray-800"
      >
        {t.rich('talim_yangiliklaridan_xabardor_bolish_uchun_telegram_kanalimizga_qoshiling', {
          span: chunks => <span className="text-blue-500">{chunks}</span>
        })}
        <div className="absolute -right-2 -top-2">
          <TelegramCircleIcon />
        </div>
      </Link>

      <ActionSection ticketId={ticketId as string} />
    </div>
  );
};

export default Result;
